var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3642 19.4102C14.6763 21.0684 12.3871 22 10.0001 22C7.61313 22 5.32392 21.0684 3.63607 19.4102C1.94822 17.7519 1 15.5029 1 13.1578C1 10.8127 1.94822 8.5636 3.63607 6.90536C3.63607 6.90536 4.37519 8.73676 6.62516 9.84201C6.62516 7.63151 7.18765 3.2105 9.98436 1C11.6874 4.31575 14.6013 5.17453 16.363 6.90536C17.2002 7.72545 17.8641 8.7 18.3167 9.773C18.7692 10.846 19.0014 11.9963 19 13.1578C19.0016 14.3192 18.7695 15.4694 18.3172 16.5424C17.8648 17.6154 17.2011 18.59 16.3642 19.4102Z",
    fill: "#FFE6A6",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.048e9ea5734b80a8593de8a03078af9c.svg";
export { ForwardRef as ReactComponent };